function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "SVGRepo_bgCarrier",
  strokeWidth: 0
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "SVGRepo_tracerCarrier",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "SVGRepo_iconCarrier"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M6,48.5v-17c0-0.553-0.448-1-1-1s-1,0.447-1,1v17c0,0.553,0.448,1,1,1S6,49.053,6,48.5z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M56,48.5v-17c0-0.553-0.448-1-1-1s-1,0.447-1,1v17c0,0.553,0.448,1,1,1S56,49.053,56,48.5z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9,30.5c-0.552,0-1,0.447-1,1v9c0,0.553,0.448,1,1,1s1-0.447,1-1v-9C10,30.947,9.552,30.5,9,30.5z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12,30.5c-0.552,0-1,0.447-1,1v9c0,0.553,0.448,1,1,1s1-0.447,1-1v-9C13,30.947,12.552,30.5,12,30.5z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18,40.5v-9c0-0.553-0.448-1-1-1s-1,0.447-1,1v9c0,0.553,0.448,1,1,1S18,41.053,18,40.5z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21,40.5v-9c0-0.553-0.448-1-1-1s-1,0.447-1,1v9c0,0.553,0.448,1,1,1S21,41.053,21,40.5z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M24,40.5v-9c0-0.553-0.448-1-1-1s-1,0.447-1,1v9c0,0.553,0.448,1,1,1S24,41.053,24,40.5z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M30,40.5v-9c0-0.553-0.448-1-1-1s-1,0.447-1,1v9c0,0.553,0.448,1,1,1S30,41.053,30,40.5z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M35,31.5c0-0.553-0.448-1-1-1s-1,0.447-1,1v9c0,0.553,0.448,1,1,1s1-0.447,1-1V31.5z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M38,31.5c0-0.553-0.448-1-1-1s-1,0.447-1,1v9c0,0.553,0.448,1,1,1s1-0.447,1-1V31.5z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M42,30.5c-0.552,0-1,0.447-1,1v9c0,0.553,0.448,1,1,1s1-0.447,1-1v-9C43,30.947,42.552,30.5,42,30.5z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M45,30.5c-0.552,0-1,0.447-1,1v9c0,0.553,0.448,1,1,1s1-0.447,1-1v-9C46,30.947,45.552,30.5,45,30.5z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M51,41.5c0.552,0,1-0.447,1-1v-9c0-0.553-0.448-1-1-1s-1,0.447-1,1v9C50,41.053,50.448,41.5,51,41.5z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4,11.5v14c0,0.553,0.448,1,1,1s1-0.447,1-1v-14c0-0.553-0.448-1-1-1S4,10.947,4,11.5z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M56,25.5v-14c0-0.553-0.448-1-1-1s-1,0.447-1,1v14c0,0.553,0.448,1,1,1S56,26.053,56,25.5z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8,25.5c0,0.553,0.448,1,1,1s1-0.447,1-1v-14c0-0.553-0.448-1-1-1s-1,0.447-1,1V25.5z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12,26.5c0.552,0,1-0.447,1-1v-14c0-0.553-0.448-1-1-1s-1,0.447-1,1v14C11,26.053,11.448,26.5,12,26.5z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17,26.5c0.552,0,1-0.447,1-1v-14c0-0.553-0.448-1-1-1s-1,0.447-1,1v14C16,26.053,16.448,26.5,17,26.5z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20,26.5c0.552,0,1-0.447,1-1v-14c0-0.553-0.448-1-1-1s-1,0.447-1,1v14C19,26.053,19.448,26.5,20,26.5z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M23,26.5c0.552,0,1-0.447,1-1v-14c0-0.553-0.448-1-1-1s-1,0.447-1,1v14C22,26.053,22.448,26.5,23,26.5z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M29,26.5c0.552,0,1-0.447,1-1v-14c0-0.553-0.448-1-1-1s-1,0.447-1,1v14C28,26.053,28.448,26.5,29,26.5z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M34,26.5c0.552,0,1-0.447,1-1v-14c0-0.553-0.448-1-1-1s-1,0.447-1,1v14C33,26.053,33.448,26.5,34,26.5z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M37,26.5c0.552,0,1-0.447,1-1v-14c0-0.553-0.448-1-1-1s-1,0.447-1,1v14C36,26.053,36.448,26.5,37,26.5z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M42,26.5c0.552,0,1-0.447,1-1v-14c0-0.553-0.448-1-1-1s-1,0.447-1,1v14C41,26.053,41.448,26.5,42,26.5z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M45,26.5c0.552,0,1-0.447,1-1v-14c0-0.553-0.448-1-1-1s-1,0.447-1,1v14C44,26.053,44.448,26.5,45,26.5z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M51,26.5c0.552,0,1-0.447,1-1v-14c0-0.553-0.448-1-1-1s-1,0.447-1,1v14C50,26.053,50.448,26.5,51,26.5z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9,44.5c-0.552,0-1,0.447-1,1v1c0,0.553,0.448,1,1,1s1-0.447,1-1v-1C10,44.947,9.552,44.5,9,44.5z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12,44.5c-0.552,0-1,0.447-1,1v1c0,0.553,0.448,1,1,1s1-0.447,1-1v-1C13,44.947,12.552,44.5,12,44.5z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15,44.5c-0.552,0-1,0.447-1,1v1c0,0.553,0.448,1,1,1s1-0.447,1-1v-1C16,44.947,15.552,44.5,15,44.5z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18,44.5c-0.552,0-1,0.447-1,1v1c0,0.553,0.448,1,1,1s1-0.447,1-1v-1C19,44.947,18.552,44.5,18,44.5z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21,44.5c-0.552,0-1,0.447-1,1v1c0,0.553,0.448,1,1,1s1-0.447,1-1v-1C22,44.947,21.552,44.5,21,44.5z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M24,44.5c-0.552,0-1,0.447-1,1v1c0,0.553,0.448,1,1,1s1-0.447,1-1v-1C25,44.947,24.552,44.5,24,44.5z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M27,44.5c-0.552,0-1,0.447-1,1v1c0,0.553,0.448,1,1,1s1-0.447,1-1v-1C28,44.947,27.552,44.5,27,44.5z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M30,44.5c-0.552,0-1,0.447-1,1v1c0,0.553,0.448,1,1,1s1-0.447,1-1v-1C31,44.947,30.552,44.5,30,44.5z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M33,44.5c-0.552,0-1,0.447-1,1v1c0,0.553,0.448,1,1,1s1-0.447,1-1v-1C34,44.947,33.552,44.5,33,44.5z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M36,44.5c-0.552,0-1,0.447-1,1v1c0,0.553,0.448,1,1,1s1-0.447,1-1v-1C37,44.947,36.552,44.5,36,44.5z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M39,44.5c-0.552,0-1,0.447-1,1v1c0,0.553,0.448,1,1,1s1-0.447,1-1v-1C40,44.947,39.552,44.5,39,44.5z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M42,44.5c-0.552,0-1,0.447-1,1v1c0,0.553,0.448,1,1,1s1-0.447,1-1v-1C43,44.947,42.552,44.5,42,44.5z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M45,44.5c-0.552,0-1,0.447-1,1v1c0,0.553,0.448,1,1,1s1-0.447,1-1v-1C46,44.947,45.552,44.5,45,44.5z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M48,44.5c-0.552,0-1,0.447-1,1v1c0,0.553,0.448,1,1,1s1-0.447,1-1v-1C49,44.947,48.552,44.5,48,44.5z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M52,45.5c0-0.553-0.448-1-1-1s-1,0.447-1,1v1c0,0.553,0.448,1,1,1s1-0.447,1-1V45.5z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8,53.5H2v-5c0-0.553-0.448-1-1-1s-1,0.447-1,1v7h8c0.552,0,1-0.447,1-1S8.552,53.5,8,53.5z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M59,47.5c-0.552,0-1,0.447-1,1v5h-5c-0.552,0-1,0.447-1,1s0.448,1,1,1h7v-7C60,47.947,59.552,47.5,59,47.5z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M52,4.5c-0.552,0-1,0.447-1,1s0.448,1,1,1h6v5c0,0.553,0.448,1,1,1s1-0.447,1-1v-7H52z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1,12.5c0.552,0,1-0.447,1-1v-5h5c0.552,0,1-0.447,1-1s-0.448-1-1-1H0v7C0,12.053,0.448,12.5,1,12.5z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M59,27.5H1c-0.552,0-1,0.447-1,1s0.448,1,1,1h58c0.552,0,1-0.447,1-1S59.552,27.5,59,27.5z"
})), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null));

const SvgIconBarcodeCustomWhl1 = (_ref) => {
  let svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#2196f3",
    width: "800px",
    height: "800px",
    viewBox: "0 0 60.00 60.00",
    id: "Capa_1",
    xmlSpace: "preserve",
    stroke: "#2196f3",
    strokeWidth: 0.0006000000000000001,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconBarcodeCustomWhl1, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-barcode-custom-whl-1.1dde7661.svg";
export { ForwardRef as ReactComponent };